import { RefObject } from 'react';
import { FormikProps } from 'formik';
import { DropResult } from 'react-beautiful-dnd';
import { IDraggableItem } from '@shared/components/draggable/DraggableList';

export interface ISortOrderModal {
  listItems: IDraggableItem[];
  formikRef: RefObject<FormikProps<ISortOrderFormValues>>;
  onClose: () => void;
  onOrderApply: (values: ISortOrderFormValues) => void;
  onMoveAdjustment: (dropResult: DropResult, moveFunc: (from: number, to: number) => void) => void;
  sortModalLoading: boolean;
  sortModalPosition: number;
}

export interface ISortOrderFormValues {
  leadSortOrder: IDraggableItem[];
}

export interface INoteModal {
  dealId: string;
  note: string;
}

export interface INoteModalProps {
  row: INoteModal;
  onClose: () => void;
  onSubmit: (data: INoteModal) => void;
  notesModalLoading: boolean;
  noteModalPosition: number;
}

export interface ITracker {
  contactId: string;
  dealId: string;
  color: string;
  firstName: string;
  lastName: string;
  assetTag: string;
  lenderName: string;
  estimatedGross: number;
  hasVsc: string;
  hasGap: string;
  hasPaf: string;
  hasCom: string;
  hasVrp: string;
  state: string;
  leadSource: string;
  assignedLp: string;
  downPayment: number;
  totalAmountFinanced: number;
  docs: string;
  receivedDate: string;
  updatedDate: string;
  note: string;
  trackingIn: string;
  trackingOut: string;
  fundedDate: string;
  assetId: string;
  link: string;
  trackerStage: string;
  trackerStageId: number;
  minTrkrStageName: string;
  maxTrkrStageName: string;
  minTrkrStageId: number;
  maxTrkrStageId: number;
  trackerStep: string;
  trackerStepId: number;
  minTrkrStepName: string;
  maxTrkrStepName: string;
  minTrkrStepId: number;
  maxTrkrStepId: number;
  sortOrder: number;
  statusColor: string;
  fontColor: string;
  isDelay: boolean;
  assignedLc: string;
  isAccountingHold: boolean;
}

export enum EGoalType {
    GrossGoal = 'FundedGrossGoal',
    DealsGoal = 'FundedDealsGoal',
}

export interface IGoals {
    goalType: EGoalType;
    amount: number;
}

export interface IUserGoals {
    id?: string;
    userId: string;
    periodId: string;
    goals: IGoals[];
}

export interface IGoalLockDate {
    isGoalLocked: boolean;
    goalDateTime: string;
  }

export enum ESortList {
  NotSet = 'Not Set',
  FundingDelay = 'Funding Delay',
  LoanAcceptedDelay = 'Loan Accepted Delay',
  InHouse = 'In House',
  InHouseDelay = 'In House Delay',
  PendingFunding = 'Pending Funding',
  DocsOut = 'Docs Out',
  DocsOutDelay = 'Docs Out Delay',
  LoanAccepted = 'Loan Accepted',
  AppSubmitted = 'App Submitted',
  WorkingLead = 'Working Lead',
  Funded = 'Funded',
  FutureDeal = 'Future Deal',
  WentDark = 'Went Dark',
  Dead = 'Dead',
  AppSubmittedApproved = 'App Submitted Approved',
  AppSubmittedPendingApproved = 'App Submitted Pending Approved',
  ReadyToPitch = 'Ready To Pitch',
} // TODO: This values are temprorary. I think I will get modal values and its colours from BE

export const sortOrderList = (Object.keys(ESortList) as (keyof typeof ESortList)[]).map((key) => ({
  id: key,
  text: ESortList[key],
  color: 'antiquewhite',
})); // TODO: this values will get from BE, it is temprorary decision
